import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from 'context/UserAuthContext'
import { Dashboard } from 'pages/Dashboard';
import { Home } from 'pages/Home';
import { LoginPage } from 'pages/login/LoginPage';

const ProtectedRoute = () => {
  const { loggedIn, loading } = useAuth();
  if (loading) {
    return <div>Loading...</div>;
  }

  // In React Router v6, you put <Outlet /> in a parent route component (often called a layout route).
  // When the URL matches one of that route’s children, React Router renders the child’s element in place
  // of the <Outlet /> while keeping the rest of the parent layout on screen. If no child route matches,
  // <Outlet /> renders nothing or the index route if defined.
  return loggedIn ? <Outlet /> : <Navigate to="/" />;
}

const RootRedirect = () => {
  const { loggedIn, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // If user on "/" route and logged in, redirect to /dashboard else /home
  return loggedIn ? <Navigate to="/ui" /> : <Navigate to="/home" />;
}

export const spedRoutes = [
  {
    path: '/',
    element: <RootRedirect />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/ui',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <Dashboard />,
      }
    ]
  },
  {
    path: '/home',
    element: <Home />
  }
];